<template>
  <div class="webdatalist">
    <div class="showLargeScreenOnly">
      <f7-list media-list class="searchbar-found" id="group-list">
        <f7-list-group v-for="(group, key) in filteredUserAccounts" :key="key">
          <f7-list-item :title="key" group-title></f7-list-item>
            <li v-for="membersGroup in group" :key="membersGroup.id">
              <div class="item-content boxRequest">
                <div class="item-inner" @click="editContactGroup(membersGroup)">
                  <div class="item-title">{{ membersGroup.name }}</div>
                </div>
                <div class="item-media">
                  <button class="button-swipe-out" @click="deleteTeamWeb(membersGroup)" :disabled="!canDeleteGroup">
                    <!-- <i class="fa fa-times-circle button-delete" ></i> -->
                    <f7-icon f7="close" class="button-delete" :style="canDeleteGroup ? {} : {'color':'grey'}"></f7-icon>
                  </button>
                </div>
              </div>
            </li>
          </f7-list-group>
        </f7-list>
      </div>

      <div class="showSmallScreenOnly">
        <f7-list media-list class="searchbar-found" id="group-list">
          <f7-list-group v-for="(group, key) in filteredUserAccounts" :key="key">
            <f7-list-item :title="key" group-title></f7-list-item>
            <f7-list-item
              swipeout
              v-for="membersGroup in group"
              :title="membersGroup.name"
              :key="membersGroup.id"
              class="boxRequest"
              @swipeout:deleted="deleteTeam(membersGroup)"
              @click="editContactGroup(membersGroup)">
              <f7-swipeout-actions>
                <f7-swipeout-button href="/accountMembers/addMemberGroup/" close class="swipeout-create action3">Edit</f7-swipeout-button>
                <f7-swipeout-button delete>Remove</f7-swipeout-button>
              </f7-swipeout-actions>
            </f7-list-item>
        </f7-list-group>
      </f7-list>
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import _ from 'lodash'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'AccountMembersGroupList',
  props: ['filterBy', 'membersGroup'],
  computed: {
    filteredUserAccounts () {
      let that = this
      let result = {}
      if (this.filterBy) {
        for (var k in that.membersGroup) {
          for (var i = 0; i < that.membersGroup[k].length; i++) {
            if (that.membersGroup[k][i].name.toLowerCase().includes(this.filterBy.toLowerCase())) {
              if (!result.hasOwnProperty(k)) {
                result[k] = []
              }
              result[k].push(that.membersGroup[k][i])
            }
          }
        }
        return result
      }

      return this.membersGroup
    }
  },
  data: () => {
    return {
      canDeleteGroup: false
    }
  },
  created () {
    this.canDeleteGroup = this.$engine.rights.rightIs('teams_supprimer', true)
  },
  methods: {
    deleteTeamWeb (membersGroup) {
      let that = this

      this.$f7.modal({
        title: that.$t('businessMembers.want_to_delete_team'),
        buttons: [
          {
            text: that.$t('common.cncl'),
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: that.$t('common.yes_label'),
            onClick: function () {
              var idTeamInList = -1
              var filteredListTeam = that.filteredUserAccounts

              for (var keys in filteredListTeam) {
                for (var group in filteredListTeam[keys]) {
                  if (filteredListTeam[keys][group].id_team === membersGroup.id_team) {
                    idTeamInList = group
                    break
                  }
                }
                if (idTeamInList !== -1) {
                  filteredListTeam[keys].splice(idTeamInList, 1)
                  break
                }
              }
              that.deleteTeam(membersGroup)
            }
          }
        ]
      })
    },
    deleteTeam (membersGroup) {
      if (!this.canDeleteGroup) {
        return
      }
      let that = this
      this.$engine.settings.set({currentMemberGroup: membersGroup})
      this.jsonStart = _.cloneDeep(this.$settings.currentMemberGroup)
      that.$engine.accounts
      .deleteGroup(that.jsonStart.id_team)
      .then(() => {
        that.$f7.alert('Team deleted', 'Success', function () {
          that.$f7.closeModal()
          that.$bus.$emit('refresh-cache-account-members')
          loadPage(that, {url: '/accountMembers/'})
        })
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
    },
    editContactGroup (membersGroup) {
      this.$engine.settings.set({currentMemberGroup: membersGroup})
      loadPage(this, {url: '/accountMembers/addMemberGroup/'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMAccountMembersGroupList.vue?a73e83e0